import ENV from  '../env.staging';
//import ENV from  '../env.production';

const libFirebase = require('firebase');
require('firebase/firestore');

class Firebase {
  static init() {
    Firebase.app = libFirebase.initializeApp(Firebase.getConfig());
  }

  static instance() {
    if (!Firebase.app) {
      Firebase.init();
    }

    return Firebase.app;
  }

  static getConfig() {
    return {
      apiKey: ENV.firebase.apiKey,
      authDomain: ENV.firebase.authDomain,
      databaseURL: ENV.firebase.databaseURL,
      projectId: ENV.firebase.projectId,
      storageBucket: ENV.firebase.storageBucket,
      messagingSenderId: ENV.firebase.messagingSenderId
    };
  }

  static getClient() {
    return libFirebase;
  }

  static database() {
    return Firebase.instance().database();
  }

  static firestore() {
    return Firebase.instance().firestore();
  }

  static storage() {
    return Firebase.instance().storage();
  }

  static auth() {
    return Firebase.instance().auth();
  }
}

export default Firebase.instance();



// WEBPACK FOOTER //
// ./src/lib/Firebase.js